"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var Eliminations_1 = require("./Eliminations");
var SimultaneousGame = /** @class */ (function () {
    function SimultaneousGame(game) {
        this.state = game;
    }
    SimultaneousGame.prototype.isLegalMove = function (playerId, move) {
        if (typeof this.getLegalMoves === 'undefined') {
            throw new Error('You must either implement "isLegalMove" or "getLegalMoves');
        }
        if (this.getLegalMoves(playerId).some(function (legalMove) { return (0, fast_deep_equal_1.default)(move, legalMove); })) {
            return true;
        }
        if ((0, Eliminations_1.hasEliminations)(this) && this.giveUpMove) {
            return (0, fast_deep_equal_1.default)(move, this.giveUpMove(playerId));
        }
        return false;
    };
    SimultaneousGame.prototype.isOver = function () {
        var _this = this;
        if (!this.getPlayerIds) {
            throw new Error('You must either implement "isOver" or "getPlayerIds"');
        }
        return !this.getPlayerIds().some(function (playerId) { return _this.isTurnToPlay(playerId); });
    };
    return SimultaneousGame;
}());
exports.default = SimultaneousGame;
